import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import C from 'classnames';
import { Card, CardBody } from 'reactstrap';
import { removeDragListener } from 'utils/dragListener';
import useConfirm from 'utils/useConfirm';
import ConnectHideIcon from 'components/atoms/icons/connectHideIcon';
import Connect from 'components/organisms/connect/connect';
import ConnectComments from 'components/organisms/connect/comments';

const ConnectModal = () => {
  const [callId, setCallId] = useState();
  const [windowExpanded, setWindowExpanded] = useState(true);
  const [pcctValues, setPcctValues] = useState({});
  const isOpen = useSelector((state) => state.connect.connectPopoutOpen);
  const connectDetails = useSelector((state) => state.connect.connectDetails);
  const wsClient = useSelector((state) => state.connect.wsClient);
  const {
    connect: { handleConnectPopoutOpen, connectDetails: handleConnectDetails },
  } = useDispatch();

  const showConfirm = useConfirm({
    message: 'Are you sure you want to exit, there are unsaved changes',
    title: 'Confirm',
  });

  const handleClick = () => {
    const details = {
      phone: '',
      guid: '',
      isRpmCall: true,
      readingId: '',
      deviceId: '',
    };
    handleConnectDetails(details);
    handleConnectPopoutOpen(false);
    removeDragListener('connect-modal-header');
  };

  const onClick = async () => {
    if (Object.keys(pcctValues).length) {
      if (await showConfirm()) {
        handleClick();
      }
    } else {
      handleClick();
    }
  };

  return (
    <div id="connect-modal" className={C('connect-modal', { isOpen })}>
      <Card>
        <CardBody>
          <div className="connect-modal-header" id="connect-modal-header">
            <h5>Accuhealth Connect</h5>
            <button className="connect-modal-close" onClick={onClick}>
              &times;
            </button>
          </div>
          <div className="connect-modal-body">
            <Connect
              isOpen={isOpen}
              phoneNumber={connectDetails.phone}
              patientGuid={connectDetails.guid}
              setCallId={setCallId}
              isRpmCall={connectDetails.isRpmCall}
              readingId={connectDetails.readingId}
              deviceId={connectDetails.deviceId}
              windowExpanded={windowExpanded}
              wsClient={wsClient}
            />
            <div className="connect-modal-body-expand-button">
              <ConnectHideIcon
                className={C(
                  windowExpanded ? 'button-expanded' : 'button-collapsed',
                )}
                onClick={() => setWindowExpanded(!windowExpanded)}
              />
            </div>
            <ConnectComments
              patientGuid={connectDetails.guid}
              isOpen={isOpen}
              callId={callId}
              isRpmCall={connectDetails.isRpmCall}
              readingId={connectDetails.readingId}
              deviceId={connectDetails.deviceId}
              pcctValues={pcctValues}
              setPcctValues={setPcctValues}
            />
          </div>
        </CardBody>
      </Card>
    </div>
  );
};

export default ConnectModal;
